/** True when the API rejected the session token (401/403 or known copy). */
export function isSessionAuthError(err) {
  const status = err?.response?.status;
  const msg = String(err?.response?.data?.error || '');
  return (
    status === 401 ||
    status === 403 ||
    /authentication required/i.test(msg) ||
    /invalid or expired session/i.test(msg)
  );
}

export const SESSION_AUTH_MESSAGE =
  'Your session expired. Log out and sign in again, then reload this page.';

/** Keep status banners readable when the API returns hundreds of duplicate errors. */
export function truncateStatusMessage(text, maxLen = 320) {
  const s = String(text || '').trim();
  if (s.length <= maxLen) return s;
  return `${s.slice(0, maxLen)}… (${s.length} chars total — see server logs for full detail)`;
}
